import React, { useState, useEffect } from "react";
import { Card, Form, Input, Button, Radio, Typography, message } from "antd";
import axios from "axios";
import SummaryApi from "../common";

const { Title, Text } = Typography;

function ForgotPassword() {
  const [step, setStep] = useState(1); 
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);
  const [resendCooldown, setResendCooldown] = useState(0);

  // ====================== SEND OTP ======================
 // Step 1: Enter Email
const sendOtp = async (selectedRole = null) => {
  if (!email) return message.warning("Please enter your email");
  setLoading(true);

  try {
    const payload = selectedRole ? { email, role: selectedRole } : { email };
    const res = await axios.post(SummaryApi.forgotPasswordSendOtp.url, payload);

    if (res.data.success) {
      setRole(res.data.role || selectedRole);
      message.success("OTP sent to email");
      setStep(2); // Proceed to OTP + new password
      startCooldown();
    } else if (res.data.options) {
      // Email exists in both tables → show role selection
      setRoleOptions(res.data.options);
      setStep(1.5);
    } else {
      message.error(res.data.message || "Error sending OTP");
    }

  } catch (err) {
    message.error(err.response?.data?.message || "Error sending OTP");
  } finally {
    setLoading(false);
  }
};

// Step 1.5: User selects role
const selectRoleAndSendOtp = async (selectedRole) => {
  if (!email) return message.warning("Email is required");
  setRole(selectedRole);
  message.info(`You selected "${selectedRole}". Sending OTP now...`);
  sendOtp(selectedRole); // resend OTP now with selected role
};


  // ====================== SELECT ROLE IF NEEDED ======================
// Step 1.5: user picks role


  // ====================== RESET PASSWORD ======================
  const resetPassword = async () => {
    if (!otp || !newPassword) return message.warning("Enter OTP and new password");
    setLoading(true);
    try {
      const res = await axios.post(SummaryApi.forgotPasswordVerifyOtp.url, {
        email,
        role,
        otp,
        newPassword,
      });
      if (res.data.success) {
        message.success("Password reset successfully!");
         if (role === "user") {
        window.location.href = "/login"; 
      } else if (role === "seller") {
        window.location.href = "/seller-signin"; 
      }else if (role === "admin") {
  window.location.href = "/platformadmin-login";
}
        // Reset form
        setStep(1);
        setEmail("");
        setRole("");
        setOtp("");
        setNewPassword("");
        setRoleOptions([]);
        setResendCooldown(0);
      }
    } catch (err) {
      message.error(err.response?.data?.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  // ====================== RESEND OTP TIMER ======================
  const startCooldown = () => {
    let time = 30; // 30 seconds
    setResendCooldown(time);
    const interval = setInterval(() => {
      time -= 1;
      setResendCooldown(time);
      if (time <= 0) clearInterval(interval);
    }, 1000);
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
      <Card style={{ width: 400, padding: "30px" }}>
        <Title level={3} style={{ textAlign: "center" }}>Forgot Password</Title>
        <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: 20 }}>
          Reset your password by entering your email
        </Text>

        {/* Step 1: Enter Email */}
        {step === 1 && (
          <Form layout="vertical">
            <Form.Item label="Email">
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
              />
            </Form.Item>
            <Button type="primary" block onClick={() => sendOtp()} loading={loading}>
              Send OTP
            </Button>
          </Form>
        )}

        {/* Step 1.5: Select Role if email exists in both */}
        {step === 1.5 && (
          <Form layout="vertical">
            <Form.Item label="Select Account Type">
              <Radio.Group onChange={(e) => selectRoleAndSendOtp(e.target.value)}>
                {roleOptions.map((r) => (
                  <Radio key={r} value={r}>
                    {r.charAt(0).toUpperCase() + r.slice(1)}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Form>
        )}

        {/* Step 2: OTP + New Password */}
        {step === 2 && (
          <Form layout="vertical">
            <Form.Item label="OTP">
              <Input
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter OTP from email"
                maxLength={6}
              />
            </Form.Item>

            <Form.Item label="New Password">
              <Input.Password
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
            </Form.Item>

            <Button
              type="primary"
              block
              onClick={resetPassword}
              loading={loading}
              disabled={!otp || !newPassword}
            >
              Reset Password
            </Button>

            {/* Resend OTP */}
            <Button
              type="link"
              disabled={resendCooldown > 0}
              onClick={() => sendOtp(role)}
            >
              {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : "Resend OTP"}
            </Button>
          </Form>
        )}
      </Card>
    </div>
  );
}

export default ForgotPassword;
